import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import epsImage from "@assets/icons/EPS.png";
import giropayImage from "@assets/icons/Giropay.png";
import "./PaymentForm.scss";
import { useLocation, useNavigate } from "react-router-dom";
import PaypalButton from "@components/paypalButton";
import { toast } from "react-toastify";

const PaymentForm = ({ formData }) => {
  const {
    address,
    email,
    kbis,
    name,
    ownerName,
    packId,
    phone,
    rib,
    packPrice,
  } = formData;
  const location = useLocation();
  const numberPrice = Number(location?.state?.pack?.price);
  const { t } = useTranslation();
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [country, setCountry] = useState("France");
  const navigate = useNavigate();
  const handlePaymentMethodChange = (_, newMethod) => {
    if (newMethod !== null) {
      setPaymentMethod(newMethod);
    }
  };

  return (
    <Box
      maxWidth={800}
      mx="auto"
      p={4}
      sx={{ backgroundColor: "white", borderRadius: 2, boxShadow: 3 }}>
      <ToggleButtonGroup
        value={paymentMethod}
        exclusive
        onChange={handlePaymentMethodChange}
        fullWidth
        sx={{ mb: 3 }}>
        <ToggleButton value="card" sx={{ textTransform: "none" }}>
          <CreditCardIcon sx={{ mr: 1 }} />
          {t("payment.card")}
        </ToggleButton>
        <ToggleButton value="eps" sx={{ textTransform: "none" }}>
          <img src={epsImage} alt="EPS" height="16" /> &nbsp;
          {t("payment.eps")}
        </ToggleButton>
        <ToggleButton value="giropay" sx={{ textTransform: "none" }}>
          <img src={giropayImage} alt="Giropay" height="16" /> &nbsp;
          {t("payment.giropay")}
        </ToggleButton>
      </ToggleButtonGroup>

      {paymentMethod === "card" && (
        <Box component="form" noValidate autoComplete="off">
          <TextField
            label={t("payment.card_number")}
            placeholder="1234 1234 1234 1234"
            fullWidth
            margin="normal"
            InputProps={{
              endAdornment: (
                <Box sx={{ display: "flex", gap: 1 }}>
                  <img
                    src="https://img.icons8.com/color/24/visa.png"
                    alt="Visa"
                  />
                  <img
                    src="https://img.icons8.com/color/24/mastercard-logo.png"
                    alt="Mastercard"
                  />
                  <img
                    src="https://img.icons8.com/color/24/amex.png"
                    alt="Amex"
                  />
                  <img
                    src="https://img.icons8.com/color/24/discover.png"
                    alt="Discover"
                  />
                </Box>
              ),
            }}
          />

          <Grid container spacing={2} mt={1}>
            <Grid item xs={6}>
              <TextField
                label={t("payment.expiry")}
                placeholder="MM / YY"
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextField label={t("payment.cvc")} placeholder="CVC" fullWidth />
            </Grid>
          </Grid>

          <Button
            fullWidth
            variant="contained"
            onClick={() => {
              toast.success("Paiement effectué avec succès ! 🎉");
              setTimeout(() => {
                navigate("/reset-password", { state: { email: email } });
              }, 2000);
            }}
            sx={{
              mt: 4,
              backgroundColor: "#007bff",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#0056b3" },
            }}>
            {t("payment.next")} &nbsp; ❯
          </Button>
          {/* <PaypalButton
            total={packPrice}
            // userData={userData}
            companyData={formData}
            // disabled={!isValidForm}
            packId={packId}
          /> */}
        </Box>
      )}
    </Box>
  );
};

export default PaymentForm;
